import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function PageIcon({ pageName, size = 'large' }) {
  const [iconUrl, setIconUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadIcon = async () => {
      try {
        const response = await axios.get(`${API}/page-icons/${pageName}`);
        if (response.data && response.data.icon_url) {
          setIconUrl(response.data.icon_url);
        }
      } catch (error) {
        console.log(`No icon for ${pageName}`);
      } finally {
        setLoading(false);
      }
    };

    loadIcon();
  }, [pageName]);

  if (loading || !iconUrl) return null;

  const sizeClasses = {
    small: 'w-16 h-16 md:w-20 md:h-20',
    medium: 'w-24 h-24 md:w-32 md:h-32',
    large: 'w-32 h-32 md:w-40 md:h-40',
    xlarge: 'w-40 h-40 md:w-48 md:h-48'
  };

  return (
    <div className="page-icon-container mb-8 flex justify-center">
      <div className="relative animate-float">
        {/* Decorative Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#E8934D]/30 to-[#E85D4D]/30 rounded-3xl blur-2xl animate-pulse"></div>
        
        {/* Icon Container */}
        <div className="relative bg-gradient-to-br from-[#F4E4C1] to-[#E8B67A] p-6 rounded-3xl shadow-2xl border-4 border-[#E8934D] transform transition-transform hover:scale-110 hover:rotate-3">
          <img 
            src={iconUrl} 
            alt={`${pageName} icon`}
            className={`${sizeClasses[size]} object-contain drop-shadow-2xl`}
            style={{ filter: 'drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3))' }}
          />
        </div>

        {/* Retro Corner Decorations */}
        <div className="absolute -top-2 -left-2 w-8 h-8 border-t-4 border-l-4 border-[#E85D4D] rounded-tl-lg"></div>
        <div className="absolute -bottom-2 -right-2 w-8 h-8 border-b-4 border-r-4 border-[#E85D4D] rounded-br-lg"></div>
      </div>
    </div>
  );
}
